import { render } from "./VerifyOTPCode.vue?vue&type=template&id=00468b51&scoped=true"
import script from "./VerifyOTPCode.vue?vue&type=script&lang=js"
export * from "./VerifyOTPCode.vue?vue&type=script&lang=js"

import "./VerifyOTPCode.vue?vue&type=style&index=0&id=00468b51&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00468b51"]])

export default __exports__